import { computed } from 'vue';
import { useStore } from '@nuxtjs/composition-api';

import { ROOT_ORGANIZATION_ID } from '@/constants';

export default (storeOverwrite) => {
  const store = storeOverwrite || useStore();

  const currentAmp = computed(() => store.state.ampStore.currentAmp);

  const canEditAmp = computed(() => {
    const { organizationId } = currentAmp.value || {};

    return organizationId && organizationId !== ROOT_ORGANIZATION_ID;
  });

  return {
    canEditAmp,
  };
};
